import { SOCIAL_PLATFORMS } from '~/constants';

export type ArgumentTypes<F extends Function> = F extends (
  ...args: infer A
) => any
  ? A
  : never;

export interface IdentifierType {
  id: string;
}

export type PlatformType = keyof typeof SOCIAL_PLATFORMS;

export interface OptionType<T> {
  value: T;
  label: string;
}

export enum PlatformContent {
  post = 'post',
  story = 'story',
  tiktok = 'tiktok',
  youtube = 'youtube',
}

export interface PlatformMetrics {
  followersCount: number;
  followsCount: number;
  mediaCount: number;
}

export type GenericIndexSignature<T extends {}> = { [k in keyof T]: T[k] };

// Kudos & reference: https://dev.to/smeijer/a-typescript-valueof-implementation-and-how-it-s-built-4gim
// TL;DR: Usage (`as const` is important here)
// const CONSTANT_OBJECT_LIKE_ENUM = { a: 'square', b: 'circle' } as const;
// const a: ValueOf<typeof CONSTANT_OBJECT_LIKE_ENUM> = 'square' // OK
// const b: ValueOf<typeof CONSTANT_OBJECT_LIKE_ENUM> = 'triangle' // error
// We can also create a type for the `typeof ...`
// type TypeFromObject = typeof CONSTANT_OBJECT_LIKE_ENUM;
export type ValueOf<T> = T[keyof T];
